import React from 'react'
import { atom, useRecoilValue, useSetRecoilState } from 'recoil'

type HeaderTokenState = {
  deviceId: string
  jwt: string
  fcmTokenId: string
  firebaseUserId: string
  version: string
  languageCode: string
}

const headerTokenState = atom<HeaderTokenState>({
  key: 'headerTokenState',
  default: {
    deviceId: '',
    jwt: '',
    fcmTokenId: '',
    firebaseUserId: '',
    version: '',
    languageCode: '',
  },
})

/**
 * HeaderTokenのgetter
 */
export const useHeaderTokenState = () => {
  return useRecoilValue(headerTokenState)
}

/**
 * HeaderTokenのsetter
 */
export const useHeaderTokenMutators = () => {
  const setState = useSetRecoilState(headerTokenState)

  const setHeaderToken = React.useCallback(
    (headerToken: HeaderTokenState) => setState({ ...headerToken }),
    [setState]
  )

  return { setHeaderToken }
}
